import service from '@/store/services/unidades-service';
import Jsona from 'jsona';

const jsona = new Jsona();

export const state = () => ({
  list: {},
  listActive: {},
  unidad: {},
  meta: {},
  url: null
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_LIST_ACTIVE: (state, listActive) => {
    state.listActive = listActive;
  },
  SET_RESOURCE: (state, unidad) => {
    state.unidad = unidad;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  }
};

export const actions = {
  list({commit, dispatch}, params = {}) {
    return service.list(params, this.$axios)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  listActive({ commit, dispatch }, params) {
    return service.listActive(params).then(({ listActive }) => {
      commit("SET_LIST_ACTIVE", listActive);
    });
  },

  get({commit, dispatch}, params) {
    return service.get(params, this.$axios)
      .then((unidad) => { commit('SET_RESOURCE', unidad); });
  },

  add({commit, dispatch}, params) {
    return service.add(params, this.$axios)
      .then((unidad) => { commit('SET_RESOURCE', unidad); });
  },

  update({commit, dispatch}, params) {
    return service.update(params, this.$axios)
      .then((unidad) => { commit('SET_RESOURCE', unidad); });
  },

  activate({commit, dispatch}, params) {
    return service.activate(params, this.$axios)
      .then((unidad) => { commit('SET_RESOURCE', unidad); });
  },

  deactivate({commit, dispatch}, params) {
    return service.deactivate(params, this.$axios)
      .then((unidad) => { commit('SET_RESOURCE', unidad); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params, this.$axios);
  },

};

const getters = {
  list: state => state.list,
  listActive: state => state.listActive,
  listTotal: state => state.meta.total, 
  unidad: state => state.unidad,
  url: state => state.url
};

const unidades = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default unidades;
